<template>
  <congress-layout
    ref="congressLayout"
    :section="updatedSection"
    :sections="sectionsList"
    :title="title"
    @changeSection="selectSection"
    classes="bg-white"
  >
    <div id="contents" class="p-8">
      <ProductsDetailDepthItem v-if="selectedSection" :content="content" />
    </div>
  </congress-layout>
</template>

<script>
import urls from "@/urls";
import messages from "@/messages";
import MatomoManager from "@/mixins/MatomoManager.vue";
import CongressLayout from "@/components/congressdetails/CongressLayout.vue";
import ProductsDetailDepthItem from "../../components/ProductsDetailDepthItem.vue";

export default {
  name: "ProductsDetailDepth",

  mixins: [MatomoManager],

  components: {
    CongressLayout,
    ProductsDetailDepthItem,
  },

  data() {
    return {
      section: "",
      title: "",
      sections: [],
      product: {},
    };
  },

  methods: {
    async loadData({ id, tab, onSucces }) {
      try {
        const instance = await this.$http({
          method: "GET",
          url: urls.products.product + "/" + +id + "/indepth",
          params: {},
        });
        this.sections = instance?.sections || [];
        this.title = instance?.title || "";
        this.section = tab || this.sections?.[0]?.path || "";

        if (onSucces) {
          onSucces();
        }

        this.$matomo.logPage(instance.name + " (Product details)");
      } catch (e) {
        console.error(e);
        this.$toast({
          message: messages.errors.productDetail,
          color: "danger",
        });
      }
    },

    selectSection(path) {
      this.section = path;
    },

    scrollToAnchor(anchorId) {
      const contentContainer = document.getElementById("contents");
      if (!contentContainer) {
        console.warn("Contenitore #contents non trovato");
      }

      const anchorElement = document.getElementById(anchorId);
      if (!anchorElement) {
        console.warn(`Elemento con id "${anchorId}" non trovato`);
      }
      anchorElement.scrollIntoView({ behavior: "smooth", block: "start" });
    },
  },

  computed: {
    inDepth() {
      return !!this.product.inDepth?.length;
    },

    updatedSection() {
      return this.section;
    },

    selectedSection() {
      return this.sections?.find((section) => section.path === this.section);
    },

    content() {
      return {
        ...this.selectedSection?.content,
        features: this.selectedSection?.features || [],
      };
    },

    sectionsList() {
      const newSections = this.sections;
      const array = [];

      for (const { label, path } of newSections) {
        array.push({ label, path });
      }

      return array;
    },
  },

  async created() {
    const anchor = this.$route.params.anchor || null;
    const id = this.$route.params.id;
    const tab = this.$route.params.tab;
    if (id) {
      this.loadData({
        id,
        tab,
        onSucces: () =>
          this.$nextTick(async () => {
            await this.$refs.congressLayout.scrollToSection(this.section);
            if (anchor) {
              this.scrollToAnchor(anchor);
            }
          }),
      });
    } else {
      console.error("No product id in route");
      this.$toast({
        message: messages.errors.productDetail,
        color: "danger",
      });
      this.$router.back();
    }
  },
};
</script>
